// Общие типы для stores
export interface AuthenticatedRequest<T> {
  data: T;
  initData: string;
}

// Вспомогательная функция для создания авторизованных запросов
export const createAuthenticatedRequest = <T>(data: T, initData: string): AuthenticatedRequest<T> => ({
  data,
  initData
});
